module.exports = __webpack_public_path__ + "static/media/garnethero.4731b345.jpg";